import React, { MouseEvent } from 'react';

import { BarItemProps } from '@nivo/bar';
import { useTheme } from '@material-ui/core';
import { useTooltip } from '@nivo/tooltip';
import clsx from 'clsx';

import { colors, barNames, maxBarHeight, Names } from '../config/constants';
import { Tooltip } from './Tooltip';
import { useStyles } from '../styles';

const style = { cursor: 'pointer' };

export const CustomBarComponent = ({ bar: { x, y, ...restProps } }: BarItemProps<any>) => {
  const theme = useTheme();
  const classes = useStyles();

  const { showTooltipFromEvent, hideTooltip } = useTooltip();
  const { data, width } = restProps;

  const id = (data?.id as Names) || barNames.clocked_in;
  const safeWidth = width > 0 ? width : 0;

  const { lightColor = colors.clocked_in.lightColor, darkColor = colors.clocked_in.darkColor } = colors[id];

  const handleClick = () => {
    data?.data?.onBarchartClick?.(id);
  };
  const handleTooltip = (event: MouseEvent<SVGRectElement>) => {
    showTooltipFromEvent(<Tooltip status={id} value={data.value} />, event, 'left');
  };

  return (
    <g
      style={style}
      onClick={handleClick}
      onMouseEnter={handleTooltip}
      onMouseMove={handleTooltip}
      onMouseLeave={hideTooltip}
    >
      <rect
        x={x}
        y={y - 17}
        rx={4}
        ry={4}
        width={safeWidth}
        height={maxBarHeight}
        fill={theme.palette.type === 'dark' ? darkColor : lightColor}
      />
      {safeWidth > 48 ? (
        <text
          x={x + 24}
          y={maxBarHeight / 2}
          className={clsx(classes.barText, {
            [classes.lightText]: id === 'clocked_in' || theme.palette.type === 'dark',
          })}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {data.formattedValue === '0' ? null : data.formattedValue}
        </text>
      ) : null}
    </g>
  );
};
